import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

let deferred = null;
const listeners = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; listeners.forEach((f) => f()); });
}

export const registerSW = () => {
  // offline, Clerk's script can't load – the app still works without it
  window.addEventListener("unhandledrejection", (e) => { if (String(e.reason?.code || e.reason?.message || "").includes("failed_to_load_clerk_js")) e.preventDefault(); });
  if ("serviceWorker" in navigator) window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => null));
};

export const cacheForOffline = (urls) => {
  navigator.serviceWorker?.controller?.postMessage({ type: "cache-urls", urls: urls.filter(Boolean) });
};

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const InstallApp = ({ className = "" }) => {
  const [, force] = useState(0);
  const [iosHelp, setIosHelp] = useState(false);
  useEffect(() => { const f = () => force((n) => n + 1); listeners.add(f); return () => listeners.delete(f); }, []);
  if (standalone() || (!deferred && !isIos())) return null;
  const install = async () => {
    if (deferred) { deferred.prompt(); await deferred.userChoice; deferred = null; listeners.forEach((f) => f()); } else setIosHelp(true);
  };
  return (
    <>
      <button onClick={install} className={`flex items-center gap-2 border border-current px-4 py-2 font-sub text-sm ${className}`} data-testid="install-app-btn">
        <Download size={15} /> WattNu als App installieren
      </button>
      <Dialog open={iosHelp} onOpenChange={setIosHelp}>
        <DialogContent className="rounded-none bg-shell" aria-describedby={undefined} data-testid="install-ios-dialog">
          <DialogTitle className="font-display text-2xl">WattNu auf den Home-Bildschirm</DialogTitle>
          <ol className="list-decimal space-y-2 pl-5 text-sm">
            <li>Tippe in Safari unten auf <Share size={14} className="inline" /> „Teilen“.</li>
            <li>Wähle „Zum Home-Bildschirm“.</li>
            <li>Tippe auf „Hinzufügen“ – fertig. Deine Merkliste ist dann auch ohne Netz da.</li>
          </ol>
          <button onClick={() => setIosHelp(false)} className="mt-2 flex items-center gap-1 self-start text-sm text-ocean"><X size={14} /> Schließen</button>
        </DialogContent>
      </Dialog>
    </>
  );
};
